"use client";

import { useLang } from "@/contexts/language-context";
import { motion } from "framer-motion";

const stats = [
  {
    num: "Dual",
    label: { en: "Pricing Built In", es: "Pricing Incorporado" },
    sub: { en: "Card payers cover the processing cost", es: "Quien paga con tarjeta cubre el procesamiento" },
  },
  {
    num: "$0",
    label: { en: "Start Plan", es: "Plan Start" },
    sub: { en: "When you process payments with Redy", es: "Si procesas tus pagos con Redy" },
  },
  {
    num: "0",
    label: { en: "Long-Term Contracts", es: "Contratos a Largo Plazo" },
    sub: { en: "Month to month", es: "Mes a mes" },
  },
  {
    num: "Live",
    label: { en: "In Real Venues", es: "En Locales Reales" },
    sub: { en: "Restaurants, bars and clubs", es: "Restaurantes, bares y clubs" },
  },
];

export default function ProofStrip() {
  const { t } = useLang();

  return (
    <div className="bg-white py-16 border-y border-black/5">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center text-[11px] font-bold tracking-widest text-redy-secondary/50 uppercase mb-12">
          {t(
            "Built for restaurants, bars and nightclubs",
            "Hecho para restaurantes, bares y discotecas"
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 gap-y-8 md:gap-y-0 md:grid-cols-4 md:divide-x md:divide-black/5"
        >
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * i }}
              className="text-center px-6 py-4"
            >
              <div className="text-[48px] md:text-[56px] font-black tracking-tight redy-text-gradient leading-none mb-2">
                {s.num}
              </div>
              <div className="text-[14px] font-black text-redy-charcoal mb-1">
                {t(s.label.en, s.label.es)}
              </div>
              <div className="text-[12px] font-medium text-redy-secondary">
                {t(s.sub.en, s.sub.es)}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
